// extracted by mini-css-extract-plugin
export default {"calculateButton":"submitButton_calculateButton__fpLq7"};